import { render, staticRenderFns } from "./ModalAdditionForm.vue?vue&type=template&id=bb7a69bc&scoped=true"
import script from "./ModalAdditionForm.vue?vue&type=script&lang=js"
export * from "./ModalAdditionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7a69bc",
  null
  
)

export default component.exports